import Entity from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/Entity";
import { workLogCategory } from "../utils/enums/WorkLogCategory";

export default interface WorkLog extends Entity {
  shortDay: Date;
  description?: string;
  internalDescription?: string;
  hours: number;
  internalHours: number;
  adjustmentHours: number;
  bonusHours: number;
  assignationExternalId: string;
  assignationName: string;
  details?: {
    prsPending: string[];
    tasksDone: string[];
    tasksInProgress: string[];
    blockers: string[];
    reportedIssues: string[];
    resolvedIssues: string[];
  };
  isWeekend?: boolean;
  isHoliday?: boolean;
  isPaused?: boolean;
  category?: workLogCategory;
  weeklyApproved?: boolean;
  projectExternalId?: string;
}

export const WORKLOG_DESCRIPTION_MAX_LENGTH = 1024;
